import { AddressHelpers } from "@/helpers/AddressHelpers";

export default function (context) {
  // Add the userAgent property to the context
  if (context.$auth.loggedIn) {
    if (context.store.state.address.List) {
      if (context.store.state.address.List.length === 0) {
        const addressHelpers = new AddressHelpers(context.$http, context.store);
        return addressHelpers.getList();
      }
    }
  }
}
